// extracted by mini-css-extract-plugin
module.exports = {"privatHero":"PrivatHero-module--privat-hero--ZRfqO"};